module.exports = __webpack_public_path__ + "img/cas2.de1a1ce5.png";